import {
  OfficeTransferDetail,
  OfficeTransferStatus,
  OfficeTransferStore,
} from "@/type/core/officeTransfer/officeTransfer.types";
import { createStore } from "effector";
import { requestGetOfficeTransfer } from "@state/officeTransfer/OfficeTransferEffects";
import { setOfficeTransfer } from "@state/officeTransfer/OfficeTransferEvents";

const initialState: OfficeTransferStore = {
  officeTransferDetail: null,
  alreadyTreated: false,
};

export const officeTransferStore = createStore<OfficeTransferStore>(
  initialState,
)
  .on(requestGetOfficeTransfer.doneData, (state, payload) => {
    const alreadyTreatedStatuses: OfficeTransferStatus[] = [
      "confirmed",
      "refused",
      "canceled",
    ];

    if (payload.ok && payload.data) {
      return {
        ...state,
        officeTransferDetail: payload.data,
        alreadyTreated: alreadyTreatedStatuses.includes(payload.data.status),
      };
    }

    return {
      ...state,
    };
  })
  .on<OfficeTransferDetail>(
    setOfficeTransfer,
    (state: OfficeTransferStore, payload: OfficeTransferDetail) => {
      return {
        ...state,
        officeTransferDetail: payload,
      };
    },
  );
